import { component } from 'picoapp';
import KeenSlider from 'keen-slider';
import lazySizes from 'lazysizes';
import { setProgressWidth, updateProgress } from 'utils/slider';

export default component((node) => {
  const slider = node.querySelector('[data-slider]');
  const prev = node.querySelector('[data-prev]');
  const next = node.querySelector('[data-next]');

  const progress = node.querySelector('[data-progress]');
  const progressBar = node.querySelector('[data-progress-bar]');

  /* eslint-disable no-new */
  new KeenSlider(slider, {
    loop: true,
    centered: true,
    mode: 'free-snap',
    slidesPerView: 1.2,
    spacing: 15,
    duration: 1200,
    breakpoints: {
      '(min-width: 768px)': {
        slidesPerView: 3,
        spacing: 30,
      },
      '(min-width: 2000px)': {
        slidesPerView: 4,
        spacing: 30,
      },
    },
    created(instance) {
      slider.classList.add('is-loaded');

      if (prev) prev.addEventListener('click', () => instance.prev());
      if (next) next.addEventListener('click', () => instance.next());

      setProgressWidth(instance, progressBar);
    },

    mounted() {
      lazySizes.autoSizer.checkElems();
    },

    move(instance) {
      setProgressWidth(instance, progressBar);
      updateProgress(instance, progressBar, progress);
    },

    slideChanged() {
      lazySizes.autoSizer.checkElems();
    },
  });

  /**
   * Lazyload video
   */

  const slides = node.querySelectorAll('[data-slide]');
  slides.forEach((slide) => {
    const video = slide.querySelector('video');
    if (video === null) return;

    slide.addEventListener('mouseover', () => {
      slide.classList.add('hovering');

      if (video.hasAttribute('data-src')) {
        video.setAttribute('src', video.getAttribute('data-src'));
        video.removeAttribute('data-src');
      }
    });

    slide.addEventListener('mouseleave', () => {
      slide.classList.remove('hovering');
    });
  });
});
